// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class IntakeV1Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param layoutId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async layoutGetByProgramId (layoutId: string, xTcScopeid?: string, xTcScopetype?: string, xProgramId?: number): Promise<AxiosResponse<object>> {
        const _url_ = '/intake/v1/Layout/{layoutId}'
            .replace('{' + 'layoutId' + '}', encodeURIComponent(String(layoutId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'layoutId' is not null or undefined
        if (layoutId === null || layoutId === undefined) {
            throw new Error('Required parameter layoutId was null or undefined when calling layoutGetByProgramId.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");
        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param layoutId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async layoutSectionGet (layoutId: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/intake/v1/LayoutSection/{layoutId}'
            .replace('{' + 'layoutId' + '}', encodeURIComponent(String(layoutId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'layoutId' is not null or undefined
        if (layoutId === null || layoutId === undefined) {
            throw new Error('Required parameter layoutId was null or undefined when calling layoutSectionGet.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
    /**
     * 
     * @param layoutId generated
     * @param xTcScopeid generated
     * @param xTcScopetype generated
     */
    public async layoutSurveyGet (layoutId: string, xTcScopeid?: string, xTcScopetype?: string): Promise<AxiosResponse<object>> {
        const _url_ = '/intake/v1/LayoutSurvey/{layoutId}'
            .replace('{' + 'layoutId' + '}', encodeURIComponent(String(layoutId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'layoutId' is not null or undefined
        if (layoutId === null || layoutId === undefined) {
            throw new Error('Required parameter layoutId was null or undefined when calling layoutSurveyGet.');
        }

        _headers_['x-tc-scopeid'] = Serializer.serialize(xTcScopeid, "string");
        _headers_['x-tc-scopetype'] = Serializer.serialize(xTcScopetype, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<object>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "object");
        }
        return response;
    }
}
